export default __webpack_public_path__ + "static/media/brand-page-header.70ff1131.jpg";